/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const PaperPlaneSolidV6 = (props) => (
  <Icon {...props} name="Paper Plane Solid V6">
    <path d="m15.987 1.152-2 12.972a1 1 0 0 1-1.373.771l-3.831-1.597-1.589 2.384A.62.62 0 0 1 6.65 16a.65.65 0 0 1-.65-.65v-3.006a1 1 0 0 1 .211-.614L13 2.999l-9.178 8.259L.615 9.92c-.352-.147-.59-.478-.613-.887s.171-.741.502-.93l14-7.972a.999.999 0 0 1 1.483 1.02z" />
  </Icon>
);

export default PaperPlaneSolidV6;
